import { AmenitiesList } from '@/components/amenities';
import { amenityCrudConfig, type Amenity } from '@/config/objects/amenities';
import { useAmenityTypeContext } from '@/pages/amenity-types/useAmenityTypeContext';
import { Loading, useApiClient, type CrudConfig } from '@startupquickstart/frontend';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from '@startupquickstart/frontend';

export function AmenityTypeAmenitiesTab() {
  const { id } = useParams<{ id: string }>();
  const { amenityType, isLoading } = useAmenityTypeContext();
  const apiClient = useApiClient();

  const amenityTypeAmenitiesConfig: CrudConfig<Amenity> = useMemo(
    () => ({
      ...amenityCrudConfig,
      entityName: 'Amenity',
      entityNamePlural: 'Amenities',
      endpoints: {
        ...amenityCrudConfig.endpoints,
        list: `/amenity-types/${id}/amenities`,
        delete: (amenityId: string) => `/amenity-types/${id}/amenities/${amenityId}`,
      },
      listView: {
        ...amenityCrudConfig.listView,
        actions: {
          add: {
            enabled: true,
            endpoint: '/amenities',
            where: amenityType
              ? {
                  amenityTypeId: {
                    not: amenityType.id,
                  },
                }
              : undefined,
            onAdd: async (amenity: Amenity) => {
              await apiClient.post(`/amenity-types/${id}/amenities`, { amenityId: amenity.id });
              toast.success('Amenity added to amenity type');
            },
          },
          view: {
            enabled: true,
          },
          remove: {
            enabled: true,
            onRemove: async (amenity: Amenity) => {
              await apiClient.delete(`/amenity-types/${id}/amenities/${amenity.id}`);
              toast.success('Amenity removed from amenity type');
            },
          },
        },
      },
    }),
    [amenityType, id, apiClient],
  );

  if (isLoading) {
    return (
      <div className="flex justify-center py-12">
        <Loading />
      </div>
    );
  }

  return <AmenitiesList config={amenityTypeAmenitiesConfig} className="p-0" baseUrl="/amenities" />;
}
